import { useState } from "react";
import styles from "./Login.module.css";

function LoginForm({ onLogin }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(login, password);
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <img src="/iconGM.png" alt="Логотип" className={styles.logo} />
        <h1 className={styles.title}>Админ панель</h1>
        <p className={styles.subtitle}>Введите данные для входа</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <input
              type="text"
              placeholder="Логин"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className={styles.btn}>
            Войти
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
